/*
 * common / alert
 */

export function initAlert() {
  $('.s-alert_trigger').on('click', function () {
    const $trigger = $(this);
    const targetId = $trigger.data('alert-target');
    const duration = $trigger.data('alert-duration') || 3000;

    // data-alert-id属性でターゲット要素を特定
    const $alert = $('[data-alert-id="' + targetId + '"]');

    // アラートを表示
    $alert.removeClass('is-hide');

    // 指定時間後に非表示
    setTimeout(() => {
      $alert.addClass('is-hide');
    }, duration);
  });
}